/**
 * @file
 * AoY Tabs: The homepage tabs that show AoY components
 */

import * as React from 'react';

// Components
import BassComponent from '../../components/BassComponent/BassComponent';
import AoyTab from './AoyTab';

// Types
import { AoyTournamentType } from './types';

interface IAoYTabsInfo {
  name: string;
  type: AoyTournamentType;
}

interface IProps {
  year?: number;
  tabs: IAoYTabsInfo[];
}
interface IState {
  activeTab: AoyTournamentType;
}

class AoyTabs extends React.PureComponent<IProps, IState> {
  public static defaultProps = {
    tabs: [
      {
        name: 'Elite',
        type: AoyTournamentType.AOY,
      },
      {
        name: 'ROY',
        type: AoyTournamentType.ROY,
      },
      {
        name: '1 Opens',
        type: AoyTournamentType.DIVISION_1_PRO,
      },
      {
        name: '2 Opens',
        type: AoyTournamentType.DIVISION_2_PRO,
      },
      {
        name: 'EQs',
        type: AoyTournamentType.EQS,
      },
      {
        name: 'Kayak',
        type: AoyTournamentType.KAYAK,
      },
    ],
  };

  public state = {
    activeTab: this.props.tabs[0].type,
  };

  public onTabClick = (activeTab: AoyTournamentType) =>
    this.setState({
      activeTab,
    });

  public render() {
    const { type: currentType } =
      this.props.tabs.find(({ type: t }) => t === this.state.activeTab) ||
      this.props.tabs[0];

    return (
      <div data-testid="aoy-tabs">
        <BassComponent
          meta={{
            componentName: '',
            exampleImgUrl: '',
            nickname: 'AoY Tabs',
            pageList: ['www.bassmaster.com'],
            renderId: 'react-app--aoy-home-tabs',
          }}
        >
          <div>
            <div className="aoy-home-tabs">
              {this.props.tabs.map(tab => (
                <button
                  key={tab.type}
                  onClick={() => this.onTabClick(tab.type)}
                  className={`button-reset aoy-home-tab ${
                    tab.type === currentType ? 'aoy-home-tab--active' : ''
                  }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            <AoyTab type={currentType} year={this.props.year} />
          </div>
        </BassComponent>
      </div>
    );
  }
}

export default AoyTabs;
